import { IUserHistoryItem } from "interfaces/models/IUserHistoryItem";
import { IActivityResponseItem } from "interfaces/responses/IActivityResponseItem";
import { IChallenge } from "interfaces/responses/IChallenge";

const mapActivityResponseToUserHistoryItem = (activityResponseItem : IActivityResponseItem) : IUserHistoryItem => {
  const userHistoryItem : IUserHistoryItem = {
    id: activityResponseItem.id,
    timeStamp: activityResponseItem.date,
    details: activityResponseItem.details,
    site: activityResponseItem.application?.baseUrl!,
    ipAddress: activityResponseItem.context?.ip!,
    action: activityResponseItem.event,
    challenges: activityResponseItem.challenges ? activityResponseItem.challenges.map((challenge: IChallenge) => (
      {
        name: challenge.name,
        response: challenge.response
      }
    )) : []
  };

  return userHistoryItem;
};

export { mapActivityResponseToUserHistoryItem };
